var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DisableCollege',{attrs:{"value":_vm.confirmDisable.modal,"title":"El servicio de skolable se encuentra suspendido para tu colegio, para obtener más detalles acerca de la suspensión, envía un correo a","description":_vm.msgDisable.error_description},on:{"desition":_vm.confirmDisableEvent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }